/**
 * Lightweight SVG line chart (no extra dependencies).
 */
const PerformanceTrendChart = ({ points = [], height = 120 }) => {
  if (!points.length) {
    return (
      <div
        className="flex items-center justify-center rounded-lg border text-sm theme-text-secondary"
        style={{
          height,
          borderColor: 'var(--color-border)',
          backgroundColor: 'var(--color-surface)'
        }}
      >
        Complete modules to see your progress trend.
      </div>
    );
  }

  const w = 320;
  const h = height;
  const pad = 8;
  const maxY = 100;
  const denom = Math.max(points.length - 1, 1);
  const xs = points.map((_, i) => pad + (i / denom) * (w - pad * 2));
  const ys = points.map((p) => pad + (1 - p.value / maxY) * (h - pad * 2));
  const d = points
    .map((_, i) => `${i === 0 ? 'M' : 'L'} ${xs[i].toFixed(1)} ${ys[i].toFixed(1)}`)
    .join(' ');

  return (
    <div className="w-full overflow-x-auto">
      <svg width={w} height={h} className="mx-auto" role="img" aria-label="Score trend chart">
        <defs>
          <linearGradient id="sdTrendFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--color-primary)" stopOpacity="0.25" />
            <stop offset="100%" stopColor="var(--color-primary)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <rect x={0} y={0} width={w} height={h} fill="var(--color-surface)" rx={8} />
        <path
          d={`${d} L ${xs[xs.length - 1]} ${h - pad} L ${xs[0]} ${h - pad} Z`}
          fill="url(#sdTrendFill)"
        />
        <path
          d={d}
          fill="none"
          stroke="var(--color-primary)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {points.map((p, i) => (
          <circle key={i} cx={xs[i]} cy={ys[i]} r={4} fill="var(--color-primary)" />
        ))}
      </svg>
      <div className="flex flex-wrap justify-center gap-2 mt-2 text-xs theme-text-secondary">
        {points.map((p, i) => (
          <span key={i}>
            {p.label}: {p.value}%
          </span>
        ))}
      </div>
    </div>
  );
};

export default PerformanceTrendChart;
